export default __webpack_public_path__ + "img/submenu-arrow-right-small.f490464f.svg";